__webpack_require__.p = "/nc-trivia-game1/";